import { Button, Container, Form, Modal } from "react-bootstrap";
import "./builder.scss";
import 'react-quill/dist/quill.snow.css';
import { useContext, useEffect, useRef, useState, useCallback, useMemo } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ProvideContext } from "../../../context/provider.context";
import { ResumeJson, getOneResumeModel } from "../../../model/resume-builder/get-one-resume.model";
import inputService from "../../../services/resume-builder/input.service";
import config from "../../../config";
import ColorPickerModal from "../../../modal/resume-builder/color-picker.modal";
import Template_0_Component from "../template/0/template-0";
import Template_1_Component from "../template/1/template-1";
import Template_2_Component from "../template/2/template-2";
import { Education, Experience, Language, ProfileModel, Skill } from "../../../model/profile.model";
import EDUCATION_LEVEL_JSON from "../../../assets/json/education-level.json";
import { InputResumeBuilderModel, InputResumeObject } from "../../../model/resume-builder/input-resume-builder.model";
import EditProfileModal from "../../../modal/edit-profile.modal";
import CoverLetter from "../cover-letter/cover-letter";
import RamaService from "../../../services/sso/rama.service";
import tokenService from "../../../services/sso/token.service";
import MenuComponent from "../../menu/menu";
import AI_ICON from "../../../assets/images/ai-icon.png";
import { TranslateModel } from "../../../model/translate.model";
import { useFilePicker } from "use-file-picker";
import ResumeBuilderInstantService from "../../../services/resume-builder/resume-builder-instance.service";
import { useProfile } from "../../../context/profile.context";
import moment from "moment";
import { FileAmountLimitValidator, FileSizeValidator, FileTypeValidator } from "use-file-picker/validators";
import { FileErrorModel } from "../../../model/error-file-select.model";
import FileLimitModal from "../../../modal/file-limit-modal";
import UtilityService from "../../../utility/utility.service";
import { CircularProgress } from "@mui/material";
import LoadingModal from "../../../modal/loading/loading";
type FormData = {
    name: string;
    cover_letter: string;
    position: string;
    experience: string;
    expertise: string;
    language: string;
    interest: string;
    education: string;
    contact: string;
}
const BuilderComponent = () => {
    const { translateGlobal }: any = useContext(ProvideContext)
    const [translate, setTranslate] = useState<TranslateModel>(translateGlobal);
    const location = useLocation();
    const navigate = useNavigate();
    const [templateId, setTemplateId] = useState("");
    const [inputTemplateModel, setInputTemplateModel] = useState<InputResumeBuilderModel>();
    const [editCoverLetter, setEditCoverLetter] = useState(false);
    const [isView, setIsView] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const [resumeUUID, setResumeUUID] = useState("");
    const [fileUpload, setFileUpload] = useState<any>();
    const [showEditProfileModal, setShowEditProfileModal] = useState(false);
    const [editProfileAction, setEditProfileAction] = useState("");
    const [isChangeColor, setIsChangeColor] = useState(false);
    const [interestingModel, setInterestingModel] = useState<string[]>(new Array());
    const [profile, error, isLoadingProfile] = useProfile();
    const [isLimitError, setIsLimitError] = useState(false);
    const [fileError, setFileError] = useState<FileErrorModel>();
    const [resultResume, setResultResume] = useState<getOneResumeModel>();
    const [isLoadingResume, setIsLoadingResume] = useState(false);
    const prefillAppliedRef = useRef(false); // Track if prefill has been applied
    const { openFilePicker, filesContent, loading, errors, clear } = useFilePicker({
        multiple: true,
        readAs: 'DataURL',
        accept: ['image/*', '.pdf'],
        limitFilesConfig: { min: 0, max: 1 },
        validators: [
            new FileAmountLimitValidator({ max: 1 }),
            new FileTypeValidator(['jpg', 'png', 'jpeg']),
            new FileSizeValidator({ maxFileSize: config.MAX_ATTACHMENT_RESUME_IMAGE_SIZE * 1024 * 1024 })
        ],
        onFilesSuccessfullySelected: ({ plainFiles, filesContent }) => {
            setFileUpload(filesContent[0])

            changeProfile(filesContent);
        },
        onFilesRejected: ({ errors }) => {
            console.log(errors);
            if (errors.length > 0) {
                const errorsResult = errors as FileErrorModel[];
                setIsLimitError(true);
                setFileError(errorsResult[0]);
            }
        }
    });

    const [scale, setScale] = useState(getScale());

    useEffect(() => {
        function handleResize() {
            setScale(getScale());
        }

        // Set the scale based on the current window width when the component mounts
        window.addEventListener('resize', handleResize);

        // Clean up the event listener when the component unmounts
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    // Helper function to determine scale based on viewport width
    function getScale(): number {
        const width = window.innerWidth;
        if (width < 768) { // sm breakpoint
            return 0.43;
        } else if (width >= 768 && width < 1024) { // md breakpoint
            return 0.9;
        } else { // lg and above
            return 1;
        }
    }
    const param = useParams();

    useEffect(() => {
        if (resultResume) {
            const locationState = location.state as { 
                prefillData?: Partial<InputResumeBuilderModel>;
                isImportResume?: boolean;
            };
            const isImportResume = locationState?.isImportResume;
            const resumeType = resultResume.resume_json.type; // Check type from resume_json
            
            const templateDefault: InputResumeBuilderModel = {
                template_id: resultResume.template_id,
                is_save: resultResume.resume_json.is_save
            };

            if (resultResume.resume_json.is_save) {
                setTemplateId(resultResume.template_id);
                initialValue(resultResume, templateDefault);
            } else {
                setTemplateId(resultResume.template_id);
                
                // If this is an import resume (from location.state or resume_json.type), use prefill data only
                if ((isImportResume || resumeType === "import") && locationState?.prefillData) {
                    // Use prefill data to initialize template - don't use profile data
                    initialValueFromPrefillData(locationState.prefillData, templateDefault, resultResume);
                } else if (profile) {
                    // Use profile data only if not import resume
                templateDefault.name = {
                    value: profile.firstName + " " + profile.lastName,
                    isEdit: false,
                    isShow: true
                }
                initialValueFromProfile(profile, templateDefault, resultResume);
                }
            }

        }
    }, [resultResume, location.state])

    useEffect(() => {
        if (param.id) {
            setResumeUUID(param.id);
            // Reset prefill flag when resume UUID changes
            prefillAppliedRef.current = false;
            // Load resume data - don't wait for profile if type is "import"
            getResumeData(param.id);
        }
    }, [param.id])

    // Handle prefill data from location.state (for existing resumes that need updating)
    // Note: For new resumes (is_save = false), prefill is handled in initialValueFromPrefillData
    useEffect(() => {
        const locationState = location.state as { 
            prefillData?: Partial<InputResumeBuilderModel>;
            isImportResume?: boolean;
        };
        
        // Only apply prefill for existing resumes (is_save = true) that need updating
        // New resumes (is_save = false) are handled in initialValueFromPrefillData
        if (
            locationState?.prefillData && 
            !locationState.isImportResume && // Skip if this is a new import resume (handled elsewhere)
            inputTemplateModel && 
            resultResume && 
            resultResume.resume_json.is_save && // Only for existing resumes
            resumeUUID &&
            !prefillAppliedRef.current
        ) {
            // Mark as applied immediately to prevent re-application
            prefillAppliedRef.current = true;
            
            // Merge prefill data with existing model
            const updatedModel = { ...inputTemplateModel };
            
            // Only merge fields that are in prefillData and don't overwrite existing non-empty values
            Object.keys(locationState.prefillData).forEach((key) => {
                const prefillField = locationState.prefillData![key as keyof InputResumeBuilderModel];
                const existingField = updatedModel[key as keyof InputResumeBuilderModel];
                
                // If field doesn't exist or is empty, use prefill data
                if (!existingField || (existingField as InputResumeObject)?.value === "" || !(existingField as InputResumeObject)?.value) {
                    (updatedModel as any)[key] = prefillField;
                }
            });
            
            setInputTemplateModel(updatedModel);
            
            // Save the updated model
            updatedModel.is_save = true;
            ResumeBuilderInstantService.updateResumeJson(resumeUUID, updatedModel).then((res) => {
                // Successfully updated - refresh resume data
                // Note: getResumeData will update resultResume, but prefillAppliedRef prevents re-application
                getResumeData(resumeUUID);
            }).catch((err) => {
                console.error("Error updating resume with prefill data:", err);
                // Reset flag on error so user can retry
                prefillAppliedRef.current = false;
            });
            
            // Clear location state to prevent re-prefilling
            // Use setTimeout to ensure state is cleared after React processes the update
            setTimeout(() => {
                window.history.replaceState({}, document.title);
            }, 0);
        }
        // Only depend on location.state and resumeUUID, not on resultResume or inputTemplateModel
        // to prevent infinite loop when getResumeData updates resultResume
    }, [location.state, resumeUUID])

    const UpdateProfileModal = (profileUpdate: ProfileModel): Promise<void> => {
        return new Promise((resolve, reject) => {
            // Don't update from profile if resume type is "import"
            if (inputTemplateModel && inputTemplateModel.type === "import") {
                // Skip profile update for import resumes
                resolve();
                return;
            }
            
            // Update profile state
            if (profileUpdate) {
                // Update resume JSON based on the current edit action
                if (inputTemplateModel && resumeUUID) {
                    const updatedModel = { ...inputTemplateModel };
                    let shouldUpdate = false;

                    // Update the corresponding field based on editProfileAction
                    if (editProfileAction === 'contact') {
                        const contactHtml = createContactFromProfileWithData(profileUpdate);
                        if (!updatedModel.contact) {
                            updatedModel.contact = { value: "", isEdit: false, isShow: true } as InputResumeObject;
                        }
                        updatedModel.contact.value = contactHtml;
                        shouldUpdate = true;
                    } else if (editProfileAction === 'experience') {
                        const expHtml = createExpFromProfileWithData(profileUpdate);
                        if (!updatedModel.experience) {
                            updatedModel.experience = { value: "", isEdit: false, isShow: true } as InputResumeObject;
                        }
                        updatedModel.experience.value = expHtml;
                        shouldUpdate = true;
                        
                        // Update position if experience was updated
                        if (!updatedModel.position) {
                            updatedModel.position = { value: "", isEdit: false, isShow: true } as InputResumeObject;
                        }
                        const lastPosition = createLastPositionWithData(profileUpdate);
                        updatedModel.position.value = lastPosition;
                    } else if (editProfileAction === 'education') {
                        const eduHtml = createEduFromProfileWithData(profileUpdate);
                        if (!updatedModel.education) {
                            updatedModel.education = { value: "", isEdit: false, isShow: true } as InputResumeObject;
                        }
                        updatedModel.education.value = eduHtml;
                        shouldUpdate = true;
                    } else if (editProfileAction === 'skills') {
                        const skillHtml = createSkillFromProfileWithData(profileUpdate);
                        if (!updatedModel.expertise) {
                            updatedModel.expertise = { value: "", isEdit: false, isShow: true } as InputResumeObject;
                        }
                        updatedModel.expertise.value = skillHtml;
                        shouldUpdate = true;
                    } else if (editProfileAction === 'about') {
                        const langHtml = createLanguageFromProfileWithData(profileUpdate);
                        if (!updatedModel.language) {
                            updatedModel.language = { value: "", isEdit: false, isShow: true } as InputResumeObject;
                        }
                        updatedModel.language.value = langHtml;
                        shouldUpdate = true;
                    }

                    if (shouldUpdate) {
                        updatedModel.is_save = true;
                        ResumeBuilderInstantService.updateResumeJson(resumeUUID, updatedModel).then((res) => {
                            // Successfully updated
                            setInputTemplateModel(updatedModel);
                            resolve();
                        }).catch((err) => {
                            console.error("Error updating resume JSON:", err);
                            reject(err);
                        });
                    } else {
                        resolve();
                    }
                } else {
                    resolve();
                }
            } else {
                resolve();
            }
        });
    }


    const clickChangeTemplateColor = useCallback(() => {
        setIsChangeColor(true);
    }, []);

    const handleCloseChangeTemplateColor = useCallback(() => {
        setIsChangeColor(false);
    }, []);

    const getResumeData = (resume_uuid) => {
        setIsLoadingResume(true);
        ResumeBuilderInstantService.getOneResume(resume_uuid).then((resobj) => {
            if (resobj.data) {
                const res: getOneResumeModel = resobj.data;
                console.log(res);
                setResultResume(res);
            }
        }).catch((error) => {
            console.error('Error loading resume:', error);
        }).finally(() => {
            setIsLoadingResume(false);
        });
    }

    const initialValue = (resultRecieve: getOneResumeModel, templ: InputResumeBuilderModel) => {
        const result = resultRecieve.resume_json;
        
        // Load type from resume_json if exists
        if (result.type) {
            templ.type = result.type;
        }
        
        if (result.color) {
            templ.color = {} as InputResumeObject;
            templ.color.value = result.color.value;
        }


        if (result.cover_letter) {
            templ.cover_letter = {} as InputResumeObject;
            templ.cover_letter.value = result.cover_letter.value;
        } else {
            templ.cover_letter = {} as InputResumeObject;
            templ.cover_letter.value = "";
        }

        if (result.name) {
            templ.name = {} as InputResumeObject;
            templ.name.value = result.name.value;
        }

        if (result.contact) {
            templ.contact = {} as InputResumeObject;
            templ.contact.value = result.contact.value;
        }

        if (result.experience) {
            templ.experience = {} as InputResumeObject;
            templ.experience.value = result.experience.value;
        }

        if (result.education) {
            templ.education = {} as InputResumeObject;
            templ.education.value = result.education.value;
        }
        if (result.expertise) {
            templ.expertise = {} as InputResumeObject;
            templ.expertise.value = result.expertise.value;
        }

        if (result.language) {
            templ.language = {} as InputResumeObject;
            templ.language.value = result.language.value;
        }

        if (result.position) {
            templ.position = {} as InputResumeObject;
            templ.position.value = result.position.value;
        }

        if (result.interest) {
            templ.interest = {} as InputResumeObject;
            templ.interest.value = result.interest.value;
        }


        setInputTemplateModel(templ);
        if (resumeUUID) {
            templ.is_save = true;
            ResumeBuilderInstantService.updateResumeJson(resumeUUID, templ).then((res) => {

            })
        }



    }

    // Initialize template from prefill data (import resume)
    const initialValueFromPrefillData = (prefillData: Partial<InputResumeBuilderModel>, templ: InputResumeBuilderModel, resultRecieve: getOneResumeModel) => {
        const result = resultRecieve.resume_json;
        templ.color = {} as InputResumeObject;
        templ.color.value = "#000";

        // Set type = "import" for imported resumes
        templ.type = "import";

        // Use prefill data directly
        if (prefillData.name) {
            templ.name = prefillData.name as InputResumeObject;
        }

        if (prefillData.contact) {
            templ.contact = prefillData.contact as InputResumeObject;
        }

        if (prefillData.position) {
            templ.position = prefillData.position as InputResumeObject;
        }

        if (prefillData.experience) {
            templ.experience = prefillData.experience as InputResumeObject;
        }

        if (prefillData.education) {
            templ.education = prefillData.education as InputResumeObject;
        }

        if (prefillData.expertise) {
            templ.expertise = prefillData.expertise as InputResumeObject;
        }

        // Set default empty values for fields not in prefill data
        if (!templ.cover_letter) {
            templ.cover_letter = {} as InputResumeObject;
            templ.cover_letter.value = "";
        }

        if (!templ.language) {
            templ.language = {} as InputResumeObject;
            templ.language.value = "";
        }

        if (!templ.interest) {
            templ.interest = {} as InputResumeObject;
            templ.interest.value = "";
        }

        setInputTemplateModel(templ);
        if (resumeUUID) {
            templ.is_save = true;
            ResumeBuilderInstantService.updateResumeJson(resumeUUID, templ).then((res) => {
                // Mark prefill as applied after saving
                prefillAppliedRef.current = true;
            }).catch((err) => {
                console.error("Error saving prefill data:", err);
            });
        }
    }

    const initialValueFromProfile = (profile: ProfileModel, templ: InputResumeBuilderModel, resultRecieve: getOneResumeModel) => {
        const result = resultRecieve.resume_json;
        templ.color = {} as InputResumeObject;
        templ.color.value = "#000";

        // Set type = "new_resume" for new resumes created from profile
        templ.type = "new_resume";

        if (profile.firstName && profile.lastName) {
            templ.name = {} as InputResumeObject;
            templ.name.value = profile.firstName + " " + profile.lastName;
        }

        if (profile.phone) {
            templ.contact = {} as InputResumeObject;
            templ.contact.value = createContactFromProfile();
        }

        if (profile.experiences) {
            templ.experience = {} as InputResumeObject;
            templ.experience.value = createExpFromProfile();
        }

        if (profile.educations) {
            templ.education = {} as InputResumeObject;
            templ.education.value = createEduFromProfile();
        }
        if (profile.skills) {
            templ.expertise = {} as InputResumeObject;
            templ.expertise.value = createSkillFromProfile();
        }

        if (profile.languages) {
            templ.language = {} as InputResumeObject;
            templ.language.value = createLanguageFromProfile();
        }

        if (profile.experiences) {
            templ.position = {} as InputResumeObject;
            templ.position.value = createLastPosition();
        }
        templ.interest = {} as InputResumeObject;
        templ.interest.value = "";
        templ.cover_letter = {} as InputResumeObject;
        templ.cover_letter.value = "";
        setInputTemplateModel(inputTemplateModel => ({ ...templ }));
        if (resumeUUID) {
            templ.is_save = true;
            ResumeBuilderInstantService.updateResumeJson(resumeUUID, templ).then((res) => {

            })
        }



    }

    const createLanguageFromProfile = () => {


        if (profile && profile.languages.length > 0) {
            let languages = "<ul>";
            profile.languages.map((item: Language, index: number) => {
                let listen = "";
                let reading = "";
                let speaking = "";
                let writing = "";
                let mainLang = "";
                if (item.language == "en") {
                    mainLang = "English"
                } else if (item.language == "th") {
                    mainLang = "Thai"
                } else if (item.language == "jp") {
                    mainLang = "Japanese"
                } else if (item.language == "ch") {
                    mainLang = "Chinese"
                }
                if (item.listening) {
                    listen = "listening";
                }
                if (item.reading) {
                    reading = "reading";
                }
                if (item.speaking) {
                    speaking = "speaking";
                }
                if (item.writing) {
                    writing = "writing";
                }
                languages += "<li>" + mainLang + ": ";
                languages += "<ul>";
                if (listen) {
                    languages += "<li>" + listen + "</li>";
                }
                if (speaking) {
                    languages += "<li>" + speaking + "</li>";
                }
                if (reading) {
                    languages += "<li>" + reading + "</li>";
                }
                if (writing) {
                    languages += "<li>" + writing + "</li>";
                }
                languages += "</ul>";
                languages += "</li>";

            })
            languages += "</ul>"
            return languages;

        } else {
            return "";
        }

    }

    // Helper functions that accept profile data as parameter
    const createContactFromProfileWithData = (profileData: ProfileModel) => {
        let contact = "";
        if (profileData && profileData.address) {
            contact += "<span><strong>Address:</strong> " + profileData.address + "</span><br>"
        } if (profileData && profileData.country) {
            contact += "<span><strong>Country:</strong> " + profileData.country + "</span><br>"
        }
        if (profileData && profileData.phone) {
            contact += "<span><strong>Tel:</strong> " + profileData.phone + "</span><br>"
        }
        if (profileData && profileData.email) {
            contact += "<span><strong>Email:</strong> " + profileData.email + "</span><br>"
        }
        if (profileData && profileData.lineId) {
            contact += "<span><strong>LINE ID:</strong> " + profileData.lineId + "</span><br>"
        } if (profileData && profileData.whatsappId) {
            contact += "<span><strong>Whats app:</strong> " + profileData.whatsappId + "</span><br>"
        }
        if (profileData && profileData.wechatId) {
            contact += "<span><strong>Wechat:</strong> " + profileData.wechatId + "</span><br>"
        }

        return contact;
    }

    const createExpFromProfileWithData = (profileData: ProfileModel) => {
        if (profileData && profileData.experiences && profileData.experiences.length > 0) {
            let workExp = "<ul>";
            profileData.experiences.map((item: Experience, index: number) => {
                workExp += "<li>"
                if (item.startDate) {
                    workExp += "<span><strong>" +
                        moment(new Date(item.startDate)).format("MMMM YYYY") + "</strong>";
                }
                if (item.stillWorkHere) {
                    workExp += "<strong> - present</strong></span><br>";
                }

                if (item.endDate && !item.stillWorkHere) {
                    workExp += "<strong> - " + moment(new Date(item.endDate)).format("MMMM YYYY") + "</strong></span><br>";
                }

                if (item.jobTitle) {
                    workExp += "<span>Position: <strong>" + item.jobTitle + "</strong></span><br>";
                }
                if (item.companyName) {
                    workExp += "<span>Company: <strong>" + item.companyName + "</strong></span><br>";
                }
                if (item.responsibilities) {
                    workExp += "<span>Responsibility: <strong>" + item.responsibilities + "</strong></span><br>";
                }
                workExp += "</li> <br>";

            })
            workExp += "</ul>";
            return workExp;
        } else {
            return ""
        }
    }

    const createEduFromProfileWithData = (profileData: ProfileModel) => {
        if (profileData && profileData.educations && profileData.educations.length > 0) {
            let workExp = "<ul>";
            profileData.educations.map((item: Education, index: number) => {
                workExp += "<li>"
                if (item.startYear) {
                    workExp += "<span><strong>" + item.startYear + "</strong>";
                }

                if (item.graduationYear) {
                    workExp += "<strong> - " + item.graduationYear + "</strong></span><br>";
                }
                let valueRet = "";
                EDUCATION_LEVEL_JSON.map((items: any, indexs: number) => {
                    if (item.educationLevel == items.value) {
                        valueRet = items.name;
                    }
                })
                if (valueRet) {
                    workExp += "<span><strong>" + valueRet + "</strong></span><br>";
                }
                if (item.fieldOfStudy && item.faculty && item.institute) {
                    workExp += "<span><strong>" + item.fieldOfStudy + ", " + item.faculty + " at " + item.institute + "</strong></span><br>";
                }


                if (!item.fieldOfStudy && !item.faculty && item.institute) {
                    workExp += "<span><strong>at " + item.institute + "</strong></span> <br>";
                }

                if (item.gpax) {
                    workExp += "<span>GPA: <strong>" + item.gpax + "</strong></span><br>";
                }

                workExp += "<br></li>";

            })
            workExp += "</ul>";
            return workExp;
        } else {
            return ""
        }
    }

    const createSkillFromProfileWithData = (profileData: ProfileModel) => {
        if (profileData && profileData.skills && profileData.skills.length > 0) {
            let skillExp = "<ul>";
            profileData.skills.map((item: Skill, index: number) => {
                skillExp += "<li>" + item.skillName + "</li>";
            })
            skillExp += "</ul>";
            return skillExp;
        } else {
            return "";
        }
    }

    const createLanguageFromProfileWithData = (profileData: ProfileModel) => {
        if (profileData && profileData.languages && profileData.languages.length > 0) {
            let languages = "<ul>";
            profileData.languages.map((item: Language, index: number) => {
                let listen = "";
                let reading = "";
                let speaking = "";
                let writing = "";
                let mainLang = "";
                if (item.language == "en") {
                    mainLang = "English"
                } else if (item.language == "th") {
                    mainLang = "Thai"
                } else if (item.language == "jp") {
                    mainLang = "Japanese"
                } else if (item.language == "ch") {
                    mainLang = "Chinese"
                }
                if (item.listening) {
                    listen = "listening";
                }
                if (item.reading) {
                    reading = "reading";
                }
                if (item.speaking) {
                    speaking = "speaking";
                }
                if (item.writing) {
                    writing = "writing";
                }
                languages += "<li>" + mainLang + ": ";
                languages += "<ul>";
                if (listen) {
                    languages += "<li>" + listen + "</li>";
                }
                if (speaking) {
                    languages += "<li>" + speaking + "</li>";
                }
                if (reading) {
                    languages += "<li>" + reading + "</li>";
                }
                if (writing) {
                    languages += "<li>" + writing + "</li>";
                }
                languages += "</ul>";
                languages += "</li>";

            })
            languages += "</ul>"
            return languages;

        } else {
            return "";
        }
    }

    const createLastPositionWithData = (profileData: ProfileModel) => {
        let jobTitle = "";

        if (profileData && profileData.experiences && profileData.experiences.length > 0) {
            jobTitle = profileData.experiences[profileData.experiences.length - 1].jobTitle
        }
        return jobTitle;
    }
    const createLastPosition = () => {
        let jobTitle = "";

        if (profile && profile.experiences.length > 0) {
            jobTitle = profile.experiences[profile.experiences.length - 1].jobTitle
        }
        return jobTitle;

    }

    const createExpFromProfile = () => {


        if (profile && profile.experiences.length > 0) {
            let workExp = "<ul>";
            profile.experiences.map((item: Experience, index: number) => {
                workExp += "<li>"
                if (item.startDate) {
                    workExp += "<span><strong>" +
                        moment(new Date(item.startDate)).format("MMMM YYYY") + "</strong>";
                }
                if (item.stillWorkHere) {
                    workExp += "<strong> - present</strong></span><br>";
                }

                if (item.endDate && !item.stillWorkHere) {
                    workExp += "<strong> - " + moment(new Date(item.endDate)).format("MMMM YYYY") + "</strong></span><br>";
                }

                if (item.jobTitle) {
                    workExp += "<span>Position: <strong>" + item.jobTitle + "</strong></span><br>";
                }
                if (item.companyName) {
                    workExp += "<span>Company: <strong>" + item.companyName + "</strong></span><br>";
                }
                if (item.responsibilities) {
                    workExp += "<span>Responsibility: <strong>" + item.responsibilities + "</strong></span><br>";
                }
                workExp += "</li> <br>";

            })
            workExp += "</ul>";
            return workExp;
        } else {
            return ""
        }



    }

    const createContactFromProfile = () => {
        let contact = "";
        if (profile && profile.address) {
            contact += "<span><strong>Address:</strong> " + profile.address + "</span><br>"
        } if (profile && profile.country) {
            contact += "<span><strong>Country:</strong> " + profile.country + "</span><br>"
        }
        if (profile && profile.phone) {
            contact += "<span><strong>Tel:</strong> " + profile.phone + "</span><br>"
        }
        if (profile && profile.email) {
            contact += "<span><strong>Email:</strong> " + profile.email + "</span><br>"
        }
        if (profile && profile.lineId) {
            contact += "<span><strong>LINE ID:</strong> " + profile.lineId + "</span><br>"
        } if (profile && profile.whatsappId) {
            contact += "<span><strong>Whats app:</strong> " + profile.whatsappId + "</span><br>"
        }
        if (profile && profile.wechatId) {
            contact += "<span><strong>Wechat:</strong> " + profile.wechatId + "</span><br>"
        }

        return contact;

    }
    const createSkillFromProfile = () => {

        if (profile && profile.skills.length > 0) {
            let skillExp = "<ul>";
            profile.skills.map((item: Skill, index: number) => {
                skillExp += "<li>" + item.skillName + "</li>";
            })
            skillExp += "</ul>";
            return skillExp;
        } else {
            return "";
        }


    }
    const createEduFromProfile = () => {


        if (profile && profile.educations.length > 0) {
            let workExp = "<ul>";
            profile.educations.map((item: Education, index: number) => {
                workExp += "<li>"
                if (item.startYear) {
                    workExp += "<span><strong>" + item.startYear + "</strong>";
                }

                if (item.graduationYear) {
                    workExp += "<strong> - " + item.graduationYear + "</strong></span><br>";
                }
                let valueRet = "";
                EDUCATION_LEVEL_JSON.map((items: any, indexs: number) => {
                    if (item.educationLevel == items.value) {
                        valueRet = items.name;
                    }
                })
                if (valueRet) {
                    workExp += "<span><strong>" + valueRet + "</strong></span><br>";
                }
                if (item.fieldOfStudy && item.faculty && item.institute) {
                    workExp += "<span><strong>" + item.fieldOfStudy + ", " + item.faculty + " at " + item.institute + "</strong></span><br>";
                }


                if (!item.fieldOfStudy && !item.faculty && item.institute) {
                    workExp += "<span><strong>at " + item.institute + "</strong></span> <br>";
                }

                if (item.gpax) {
                    workExp += "<span>GPA: <strong>" + item.gpax + "</strong></span><br>";
                }

                workExp += "<br></li>";

            })
            workExp += "</ul>";
            return workExp;
        } else {
            return ""
        }



    }




    const handleCloseEditProfile = () => {
        setShowEditProfileModal(false);
    }



    const clickView = () => {
        setIsView(true);
        if (inputTemplateModel) {
            // inputTemplateModel.profile_img = fileImg
            inputTemplateModel.is_save = true;
            console.log(inputTemplateModel);
            
            if (inputTemplateModel.is_profile_img) {
                if (inputTemplateModel.profile_img[0].includes("data:image")) {
                    // Handle profile image case if needed
                }
            } else {
                setIsSaving(true);
                ResumeBuilderInstantService.updateResumeJson(resumeUUID, inputTemplateModel)
                    .then((res) => {
                        if (res.status == 200) {
                            UtilityService().clickSendEvent("save_resume_and_view", "submit");
                            // navigate(navigateConfig.resume.main);
                            window.open(config.url + 'resume/view/' + resumeUUID, "_self");
                        }
                    })
                    .catch((error) => {
                        console.error('Error saving resume:', error);
                    })
                    .finally(() => {
                        setIsSaving(false);
                    });
            }
        }
    }
    const DataURIToBlob = (dataURI: string) => {
        const splitDataURI = dataURI.split(',')
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0]
        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i)
        return new Blob([ia], { type: mimeString })
    }

    const changeProfile = (fileContent) => {
        let fileImg = fileContent;

        if (fileImg) {
            const file = DataURIToBlob(fileImg[0].content);
            ResumeBuilderInstantService.updateProfileImg(resumeUUID, file, fileImg[0].name).then((res) => {

                if (res.data) {
                    if(resultResume){
                        const resultResumeMod = { ...resultResume };
                        if(res.data.image_url){
                            resultResumeMod.profile_img = res.data.image_url;
                            setResultResume(resultResumeMod);
                        }
                    }
                    
                   
                }
            });
        }
        // if (resultResume) {

        //     const resultResumeMod = { ...resultResume };
        //     if (resultResumeMod.profile_img) {

        //         resultResumeMod.profile_img = fileImg[0].content;
        //     }
        //     setResultResume(resultResumeMod);
        // }
    }

    const onTextChange = (action, value) => {
        if (inputTemplateModel) {
            const inputTemplateMod = { ...inputTemplateModel };
            if (action == 'name') {
                if (inputTemplateMod.name) {
                    inputTemplateMod.name.value = value
                }
            } else if (action == 'position') {
                if (inputTemplateMod.position) {
                    inputTemplateMod.position.value = value
                }
            }

            setInputTemplateModel(inputTemplateMod);
        }

    }

    const onEdit = (action, value) => {

        if (inputTemplateModel) {
            const inputTemplateMod = { ...inputTemplateModel };
            UtilityService().clickSendEvent("resume_builder_edit_"+action, "click");
            if (action == 'name') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.name) {
                    inputTemplateMod.name = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                } else {
                    inputTemplateMod.name.isEdit = value
                }
            }
            if (action == 'contact') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.contact) {
                    inputTemplateMod.contact = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                }
                    if (value) {
                        setShowEditProfileModal(true)
                        setEditProfileAction('contact');
                }
            }
            if (action == 'position') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.position) {
                    inputTemplateMod.position = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                } else {
                    inputTemplateMod.position.isEdit = value
                }
            }
            if (action == 'experience') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.experience) {
                    inputTemplateMod.experience = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                }
                    if (value) {
                        setShowEditProfileModal(true)
                        setEditProfileAction('experience');
                }
            }
            if (action == 'education') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.education) {
                    inputTemplateMod.education = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                }
                    if (value) {
                        setShowEditProfileModal(true)
                        setEditProfileAction('education');
                }
            }
            if (action == 'language') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.language) {
                    inputTemplateMod.language = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                }
                    if (value) {
                        setShowEditProfileModal(true)
                        setEditProfileAction('about');
                }
            }
            if (action == 'expertise') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.expertise) {
                    inputTemplateMod.expertise = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                }
                    if (value) {
                        setShowEditProfileModal(true)
                        setEditProfileAction('skills');
                }
            }

            if (action == 'interest') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.interest) {
                    inputTemplateMod.interest = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                }
                    if (value) {
                        setShowEditProfileModal(true)
                        setEditProfileAction('interesting');
                }
            }

            if (action == 'cover_letter') {
                // Create field if it doesn't exist
                if (!inputTemplateMod.cover_letter) {
                    inputTemplateMod.cover_letter = {
                        value: "",
                        isEdit: true,
                        isShow: true
                    } as InputResumeObject;
                }
                    if (value) {
                        setEditCoverLetter(true);
                }
            }
            if (action == 'profile_img') {
                openFilePicker();
            }


            setInputTemplateModel(inputTemplateMod);
        }

    }


    const setInterestingUpdate = (interestingModel: string[]) => {

        if (interestingModel && inputTemplateModel && inputTemplateModel.interest && resumeUUID) {
            setInterestingModel(interestingModel);
            const inputTempMod = { ...inputTemplateModel };
            if (inputTempMod.interest) {
                let interestStr = "<ul>";
                interestingModel.map((item: string, index: number) => {
                    interestStr += "<li>" + item + "</li>";
                })
                interestStr += "</ul>";
                inputTempMod.interest.value = interestStr;
                
                // Update resume JSON before closing modal
                inputTempMod.is_save = true;
                ResumeBuilderInstantService.updateResumeJson(resumeUUID, inputTempMod).then((res) => {
                    // Successfully updated
                setInputTemplateModel(inputTempMod);
                }).catch((err) => {
                    console.error("Error updating resume JSON:", err);
                    // Still update state even if API call fails
                    setInputTemplateModel(inputTempMod);
                });
            }

        }
    }

    const setColorMain = useCallback((colorString: string) => {
        setInputTemplateModel(prev => {
            if (!prev || !prev.color) return prev;
            return {
                ...prev,
                color: {
                    value: colorString,
                    isEdit: prev.color.isEdit ?? false,
                    isShow: prev.color.isShow ?? true
                }
            };
        });
    }, []);

    const setCoverLetterUpdate = (coverLetter) => {
        if (inputTemplateModel && resumeUUID) {
            const inputTemplMod = { ...inputTemplateModel };
            if (coverLetter && inputTemplMod.cover_letter) {
                inputTemplMod.cover_letter.value = coverLetter;
            } else {
                inputTemplMod.cover_letter = {} as InputResumeObject;
                inputTemplMod.cover_letter.value = coverLetter
            }

            // Update resume JSON before closing modal
            inputTemplMod.is_save = true;
            ResumeBuilderInstantService.updateResumeJson(resumeUUID, inputTemplMod).then((res) => {
                // Successfully updated
                setInputTemplateModel(inputTemplMod);
                setEditCoverLetter(false);
            }).catch((err) => {
                console.error("Error updating resume JSON:", err);
                // Still close modal even if update fails
                setInputTemplateModel(inputTemplMod);
                setEditCoverLetter(false);
            });
        } else {
            setEditCoverLetter(false);
        }
    }

    const renderField = (fieldKey: string, title: string) => {
        if (inputTemplateModel && resultResume) {
            const fieldData = inputTemplateModel[fieldKey];

            // If field doesn't exist, show empty field with "Add" button
            if (!fieldData) {
                return (
                    <div className="builder-form-item-left">
                        <div className="builder-form-item-title-control">
                            <span className="builder-form-item-title">
                                {title} {title == "Cover letter" && 
                                    <img src={AI_ICON} className="builder-form-icon-ai"></img>
                                }
                            </span>
                            <span className="builder-form-item-edit" onClick={() => {
                                // Initialize empty field and enable edit mode
                                const inputTempMod = { ...inputTemplateModel };
                                (inputTempMod as any)[fieldKey] = {
                                    value: "",
                                    isEdit: true,
                                    isShow: true
                                } as InputResumeObject;
                                setInputTemplateModel(inputTempMod);
                                // Call onEdit to handle special fields (experience, education, etc.)
                                onEdit(fieldKey, true);
                            }}>
                                {translate.other.add || "เพิ่มข้อมูล"}
                            </span>
                        </div>
                        <div className="builder-form-item-divider"></div>
                        <span className="builder-form-item-value" style={{ color: 'var(--text-gray-color)', fontStyle: 'italic' }}>
                            {translate.error.no_information || "ยังไม่มีข้อมูล"}
                        </span>
                    </div>
                );
            }

            return (
                <div className="builder-form-item-left">
                    <div className="builder-form-item-title-control">
                        <span className="builder-form-item-title">
                            {title} {title == "Cover letter" && 
                                <img src={AI_ICON} className="builder-form-icon-ai"></img>
                            }
                        </span>
                        {
                            (fieldData.isEdit && fieldKey != "color") ?
                                <span className="builder-form-item-edit" onClick={() => onEdit(fieldKey, false)}>
                                    {translate.other.save}
                                </span> : fieldKey != "color" &&
                                <span className="builder-form-item-edit" onClick={() => onEdit(fieldKey, true)}>
                                    {translate.other.edit}
                                </span>
                        }
                    </div>
                    <div className="builder-form-item-divider"></div>
                    {
                        fieldKey == 'experience' || fieldKey == 'education' && fieldData.isEdit ?

                            <span className="builder-form-item-value" dangerouslySetInnerHTML={{ __html: fieldData.value }}></span> :
                            fieldKey == 'position' && fieldData.isEdit && fieldData.value ?
                                <Form.Select className="builder-form-item-input"
                                    defaultValue={fieldData.value}
                                    onChange={(e) => onTextChange(fieldKey, e.target.value)}>
                                    {profile &&
                                        inputTemplateModel.type !== "import" && // Don't show profile data if type is "import"
                                        profile.experiences && profile.experiences.length > 0 &&
                                        profile.experiences.map((item: Experience, index: number) => {
                                            return (
                                                <option value={item.jobTitle} key={index}>{item.jobTitle}</option>
                                            )

                                        })
                                    }

                                </Form.Select>
                                : fieldKey == 'position' && fieldData.isEdit && !fieldData.value ?
                                    <span className="builder-form-item-value">{translate.error.input_exp}</span> :
                                    fieldData.isEdit ?
                                        <Form.Control
                                            className="builder-form-item-input"
                                            type="text"
                                            value={fieldData.value}
                                            onChange={(e) => onTextChange(fieldKey, e.target.value)}
                                        /> :
                                        fieldKey == 'color' ? <div className="builder-form-color-control">
                                            {
                                                fieldData.value &&
                                                <>
                                                    <div className="builder-form-color-value" style={{ backgroundColor: fieldData.value }}></div>
                                                    <span>{fieldData.value}</span>
                                                </>

                                            }

                                        </div> :

                                            <span className="builder-form-item-value" dangerouslySetInnerHTML={{ __html: fieldData.value }}></span>

                    }
                    {
                        fieldKey == 'color' &&
                        <><Button className="button-form-color-button" onClick={clickChangeTemplateColor}>{translate.resume_builder.color_change}</Button></>
                    }
                    {
                        !fieldData.value && fieldKey != 'position' && fieldKey != 'profile_img' &&
                        <span className="builder-form-item-value">{translate.error.no_information}</span>
                    }
                    {
                        fieldKey == 'profile_img' && fieldData.length == 0 &&
                        <span className="builder-form-item-value">{translate.error.no_information}</span>
                    }
                </div>
            );
        }

    }

    // ...

    const fieldMapping = {
        color: translate.profile.color_resume,
        name: translate.profile.first_name,
        contact: translate.profile.contact,
        position: translate.job_apply.position,
        cover_letter: translate.resume_builder.cover_letter,
        experience: translate.application_form.experiences,
        education: translate.application_form.educations,
        language: translate.application_form.language,
        expertise: translate.application_form.skills,
        interest: translate.profile.activiy_interest
    };

    // Memoize template rendering to prevent unnecessary re-renders
    const renderedTemplate = useMemo(() => {
        if (!inputTemplateModel || !resultResume) return null;
        
        // Don't pass profile to template if type is "import"
        const shouldUseProfile = inputTemplateModel.type !== "import";
        
        if (Number(templateId) === 0) {
            return <Template_0_Component templ={inputTemplateModel} containerRef={containerRef} resultResume={resultResume} />;
        } else if (Number(templateId) === 1) {
            return <Template_1_Component templ={inputTemplateModel} containerRef={containerRef} resultResume={resultResume} />;
        } else if (Number(templateId) === 2) {
            return <Template_2_Component templ={inputTemplateModel} containerRef={containerRef} profile={shouldUseProfile ? profile : undefined} />;
        }
        return null;
    }, [inputTemplateModel, resultResume, templateId, containerRef, profile]);


    return (

        <div className="main-control">
            <MenuComponent></MenuComponent>
            <div className="builder">
                {
                    // Don't wait for profile if resume type is "import"
                    ((inputTemplateModel?.type !== "import" && isLoadingProfile) || isLoadingResume) ? (
                        <Container className="builder-control">
                            <div className="builder-loading-control">
                                <div className="builder-loading-flex">
                                    <CircularProgress className="builder-loading"></CircularProgress>
                                    <span className="builder-loading-text">{translate.other.loading || "กำลังโหลด..."}</span>
                                </div>
                            </div>
                        </Container>
                    ) : inputTemplateModel &&

                    <Container className="builder-control">
                        <div className="builder-form-control">


                            <div className="builder-form-item-control">
                                {
                                    resultResume && resultResume.is_profile_img &&
                                    <div className="builder-form-item-left">
                                        <div className="builder-form-item-title-control">
                                            <span className="builder-form-item-title">
                                                {translate.application_form.profileImage}
                                            </span>
                                            {

                                                <span className="builder-form-item-edit" onClick={() => onEdit("profile_img", true)}>
                                                    {translate.other.edit}
                                                </span>
                                            }
                                        </div>
                                        <div className="builder-form-item-divider"></div>
                                        <img className="builder-form-item-profile" src={resultResume.profile_img} onClick={openFilePicker}></img>
                                    </div>
                                }

                                {Object.keys(fieldMapping).map(fieldKey => renderField(fieldKey as keyof typeof inputTemplateModel, fieldMapping[fieldKey]))}


                            </div>
                            <div className="builder-form-item-control-right ">
                                <div className="builder-form-right-page-control" style={{
                                    transform: `scale(${scale})`,

                                }}>
                                    {renderedTemplate}
                                </div>
                            </div>

                        </div>
                        <Button className="builder-preview-button" onClick={clickView}>{translate.other.save_preview}</Button>
                    </Container>
                }

            </div>

            {
                showEditProfileModal && <EditProfileModal open={showEditProfileModal} setOpen={handleCloseEditProfile} action={editProfileAction}
                    profile={profile} interestingModel={interestingModel}
                    setInterestingUpdate={setInterestingUpdate} setProfile={UpdateProfileModal} isNew={false} isApplicationForm={false}
                    onUpdateResume={UpdateProfileModal}></EditProfileModal>
            }

            {
                editCoverLetter &&
                <Modal show={editCoverLetter}>
                    <Modal.Body>
                        <CoverLetter setCoverLetterUpdate={setCoverLetterUpdate} templ={inputTemplateModel} profile={profile}
                        setEditCoverLetter={setEditCoverLetter}></CoverLetter>
                    </Modal.Body>
                </Modal>
            }
            {
                isChangeColor && <ColorPickerModal open={isChangeColor} setOpen={handleCloseChangeTemplateColor} setColorMain={setColorMain}></ColorPickerModal>
            }
            {
                isLimitError &&

                <FileLimitModal open={isLimitError} handleClose={() => setIsLimitError(false)} fileError={fileError} limitSize={config.MAX_ATTACHMENT_RESUME_IMAGE_SIZE} ></FileLimitModal>
            }
            {
                isSaving && <LoadingModal open={isSaving} onclose={() => {}}></LoadingModal>
            }

        </div>
    )
}

export default BuilderComponent;